<a class="nav-link" [href]="signPostingLink()" id="nav-singposting-service" target="_blank">
  <div class="icon-container">
    <i class="fa-solid fa-hand-holding-hand" style="color: #01c9fc; font-size: 20px;"></i>
  </div>
  Struggling to cope?<br/>
  <div id="signposting"><span>Signposting to Support Services</span></div>
</a>
